import { EntityApiService } from '@dfl/react-security';
import { IAreaCategory } from 'modules/settings/nomenclatures/area-category/interfaces';

class AreaCategoryService extends EntityApiService<IAreaCategory> {}

export default new AreaCategoryService('/ms-core/api/category-area');
